enum StarbucksMerchantId {
  Starbucks = 'starbucks-merchant-id',
  Kowalskis = '97035900006',
}

export { StarbucksMerchantId };
